<template>
    <card minify="true">
        <card-header>
            <card-subtitle><translate>Anfrage: </translate> {{ askForQuote.pfnumber }}</card-subtitle>
        </card-header>
        <card-content v-if="!bidRoundCanceled">
            <div class="row">
                <div class="col">
                    <sketch-preview :sketchFile="askForQuote.producer_sketch_file"></sketch-preview>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <description-group grid="true">
                        <description-element v-if="askForQuote.producer_sketch_file" :caption="sketchFileName" :title="this.$gettext('Zeichnung')" :link="sketchFileLink" icon="document-file-download" />
                        <description-element v-if="askForQuote.producer_cad_file" :caption="cadFileName" :title="this.$gettext('3D-Daten')" :link="cadFileLink" icon="document-file-download"  />
                    </description-group>
                </div>
            </div>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardSubtitle from '@partfactory/Shared/Card/CardSubtitle';
import CardContent from '@partfactory/Shared/Card/CardContent';
import DescriptionElement from '@partfactory/Shared/Elements/DescriptionElement';
import DescriptionGroup from '@partfactory/Shared/Elements/DescriptionGroup';
import SketchPreview from '@partfactory/Shared/Elements/SketchPreview';
export default {
    name: 'ComponentSidebarSketch',
    components: {SketchPreview, DescriptionGroup, DescriptionElement, CardContent, CardSubtitle, CardHeader, Card},
    props: {
        askForQuote: Object
    },
    computed: {
        sketchFileName() {
            return this.askForQuote.producer_sketch_file.file_informations.original_name;
        },
        sketchFileLink() {
            return this.$$route('sketch-file.download', {'sketchFile': this.askForQuote.producer_sketch_file.id});
        },
        cadFileName() {
            return this.askForQuote.producer_cad_file.file_informations.original_name;
        },
        cadFileLink() {
            return this.$$route('cad-file.download', {'cadFile':  this.askForQuote.producer_cad_file.id});
        },
        bidRoundCanceled() {
            return this.askForQuote.bid_rounds[0].canceled;
        },
    }
};
</script>
